module.exports = __webpack_public_path__ + "static/img/digitalize.6c3c8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCodePhone/digitalize.png
// module id = gzH/
// module chunks = 0